import {Component, Output, EventEmitter, Input} from '@angular/core';

/*##################################################################################* 
 * COMPOSANT SPRO : spro-button-dupliquer
 * 
 * DESCRIPTION : Bouton dupliquer
 * 
 ##################################################################################*/

@Component({
  selector: 'spro-button-dupliquer',
  template: `
    <button class="k-button"
            [type]="w_type"
            [title]="w_popup | translate"
            [disabled]="!f_actif"
            (click)="proc_click()"
    >
      <i class="k-icon k-i-copy"></i>
      <span *ngIf="f_affLib">{{ 'Boutons.dupliquer' | translate }}</span>
    </button>
  `,
})
export class spro_cls_button_dupliquer {

  /** Type du bouton a afficher */
  @Input() w_type: string = "button";
  /** Texte de la popup */
  @Input() w_popup: String = 'Boutons.actualiser';
  /** Affichage du libellé */
  @Input() f_affLib: Boolean = false;
  /** Pour désactiver le bouton */
  @Input() f_actif: boolean = true;
  
  /** Déclaration événement sur click */
  @Output() e_click: EventEmitter<any> = new EventEmitter();

  /**
   * Evénements sur click
   */
  public proc_click(): void {
    this.e_click.emit();
  }
}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/buttons/spro-button-dupliquer/spro-button-dupliquer.component.ts